import { Component, DestroyRef, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { timer } from 'rxjs';

@Component({
  imports: [IconBadgeComponent, IconComponent, TranslateModule, MatButtonModule],
  selector: 'app-filter-badge',
  styleUrl: './filter-badge.component.scss',
  templateUrl: './filter-badge.component.html',
})
export class FilterBadgeComponent {
  /** Translation key of the label before the pill, e.g. "Filtered Creator". */
  public readonly label = input.required<string>();
  public readonly name = input<string | null>('');
  public readonly showAvatar = input<boolean>(false);
  public readonly avatar = input<string | null | undefined>(undefined);

  public readonly removed = output<void>();

  public readonly leaving = signal(false);

  private readonly destroyRef = inject(DestroyRef);

  public startLeave(): void {
    this.leaving.set(true);
    timer(200)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.removed.emit());
  }
}
